import { Main } from "./componetns/Main";
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	formWrapper: {
		marginTop: theme.spacing(5),
		marginBottom: theme.spacing(8),
	}
}));

const App = () => {
	const classes = useStyles();

	return (
		<Grid container>
			<Grid item xs={12}>
				<Container maxWidth="md">
					<div className={classes.formWrapper}>

							<Main />
					</div>
				</Container>
			</Grid>
		</Grid>
	);
};

export default App;
